import { BrainstormActions, ListBranchesAction, ListDepartmentsAction, ListCollaboratorsAction, GetCollaboratorAction, ListImplementerIdeasAction, ListCollaboratorIdeasAction, GetIdeaAction, SaveIdeaAction } from './../action/BrainstormActions';
import { BrainstormActionTypes, UserActionTypes } from '../action';
import { Injectable } from "../../../node_modules/@angular/core";
import { Actions, Effect } from "@ngrx/effects";
import { Observable } from 'rxjs/Observable';

import { BrainstormService } from '../../services/BrainstormService';

@Injectable()
export class BrainstormEffects {

    constructor(
        private actions: Actions<BrainstormActions>,
        private brainstormService: BrainstormService
    ) {

    }

    @Effect()
    branchList$ = this.actions.ofType(BrainstormActionTypes.LIST_BRANCHES)
        .map((action: ListBranchesAction) => action)
        .switchMap(action => this.brainstormService.listBranches(action.payload.clientId)
            .map(response => ({ type: BrainstormActionTypes.LIST_BRANCHES_SUCCESS, branchesData: response }))
            .catch(error => Observable.of({ type: BrainstormActionTypes.LIST_BRANCHES_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    departmentList$ = this.actions.ofType(BrainstormActionTypes.LIST_DEPARTMENTS)
        .map((action: ListDepartmentsAction) => action)
        .switchMap(action => this.brainstormService.listDepartments(action.payload.branchId)
            .map(response => ({ type: BrainstormActionTypes.LIST_DEPARTMENTS_SUCCESS, departmentsData: response }))
            .catch(error => Observable.of({ type: BrainstormActionTypes.LIST_DEPARTMENTS_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    collaboratorsList$ = this.actions.ofType(BrainstormActionTypes.LIST_COLLABORATORS)
        .map((action: ListCollaboratorsAction) => action)
        .switchMap(action => this.brainstormService.listCollaborators(action.payload.departmentId)
            .map(response => ({ type: BrainstormActionTypes.LIST_COLLABORATORS_SUCCESS, collaboratorsData: response }))
            .catch(error => Observable.of({ type: BrainstormActionTypes.LIST_COLLABORATORS_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    collaboratorData$ = this.actions.ofType(BrainstormActionTypes.GET_COLLABORATOR)
        .map((action: GetCollaboratorAction) => action)
        .switchMap(action => this.brainstormService.getCollaborator(action.payload.collaboratorId)
            .map(response => ({ type: BrainstormActionTypes.GET_COLLABORATOR_SUCCESS, collaboratorData: response }))
            .catch(error => Observable.of({ type: BrainstormActionTypes.GET_COLLABORATOR_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    clientIdeasList$ = this.actions.ofType(BrainstormActionTypes.LIST_IDEAS_IMPLEMENTER)
        .map((action: ListImplementerIdeasAction) => action)
        .switchMap(action => this.brainstormService.listImplementerIdeas(action.payload.userId)
            .map(response => ({ type: BrainstormActionTypes.LIST_IDEAS_IMPLEMENTER_SUCCESS, implementerIdeasData: response }))
            .catch(error => Observable.of({ type: BrainstormActionTypes.LIST_IDEAS_IMPLEMENTER_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    collaboratorIdeasList$ = this.actions.ofType(BrainstormActionTypes.LIST_IDEAS_COLLABORATOR)
        .map((action: ListCollaboratorIdeasAction) => action)
        .switchMap(action => this.brainstormService.listCollaboratorIdeas(action.payload.userId)
            .map(response => ({ type: BrainstormActionTypes.LIST_IDEAS_COLLABORATOR_SUCCESS, collaboratorIdeasData: response }))
            .catch(error => Observable.of({ type: BrainstormActionTypes.LIST_IDEAS_COLLABORATOR_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    ideaGet$ = this.actions.ofType(BrainstormActionTypes.GET_IDEA)
        .map((action: GetIdeaAction) => action)
        .switchMap(action => this.brainstormService.getIdea(action.payload.ideaId)
            .map(response => ({ type: BrainstormActionTypes.GET_IDEA_SUCCESS, ideaData: response }))
            .catch(error => Observable.of({ type: BrainstormActionTypes.GET_IDEA_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    ideaSave$ = this.actions.ofType(BrainstormActionTypes.SAVE_IDEA)
        .map((action: SaveIdeaAction) => action)
        .switchMap(action => this.brainstormService.saveIdea(action.payload.data)
            .map(response => ({ type: BrainstormActionTypes.SAVE_IDEA_SUCCESS, ideaData: response }))
            .catch(error => Observable.of({ type: BrainstormActionTypes.SAVE_IDEA_ERROR, errorPayload: { errorStatus: error.status } }))
        );

  @Effect() errorStatus401$ = this.actions
    .map(action => action.errorPayload)
    .filter(payload => payload && (payload.errorStatus === 401 || payload.errorStatus === 0))
    .switchMap(() => Observable.of({ type: UserActionTypes.USER_EXPIRED }));

}


// WEBPACK FOOTER //
// ./src/store/effects/BrainstormEffects.ts